import { featureGroupBlueprint } from "@made-people/blueprint-feature-group/blueprint";

featureGroupBlueprint.override({
  slots: {
    wrapper: "p-2 md:p-4 lg:p-6 bg-surface-1 flex justify-around gap-2",
    item: "flex flex-col items-center justify-start gap-2",
    icon: "w-8 h-8 flex justify-center items-center md:w-10 md:h-10 lg:w-12 lg:h-12 object-contain",
    text: "text-body-sm md:text-body-md text-center",
    textLabel: "font-bold",
    textDescription: "",
  },
});
